import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ImpersonationBroker } from '../../viewmodels/AppViewModels';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

export const MY_TEMPLATES_QUERY_KEY = '/templates/<industry>/me';

export function useMyTemplatesQuery<T extends object>({
	impersonationContext,
	enabled = true,
	excludeExpired = true,
	industry,
	sort = 'desc',
	sortBy = 'lastModifiedDate',
	templateType = Api.TemplateType.Email,
	meta,
}: {
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	excludeExpired?: boolean;
	industry: Api.Industry;
	sort?: 'asc' | 'desc';
	sortBy?: string;
	templateType?: Api.TemplateType;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();

	return useQuery({
		enabled,
		queryFn: () => {
			const queryParams: any = {
				excludeExpired,
				sort,
				sortBy,
				templateType,
			};

			return userSession.webServiceHelper.callAsync<T[]>(
				ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams,
					urlPath: `template/${encodeURIComponent(industry)}/me`,
				}),
				'GET'
			);
		},
		queryKey: [MY_TEMPLATES_QUERY_KEY, templateType, excludeExpired, industry, sort, sortBy],
		meta,
	});
}

export const invalidateMyTemplates = ({ templateType }: { templateType: Api.TemplateType }) => {
	reactQueryClient.invalidateQueries({ queryKey: [MY_TEMPLATES_QUERY_KEY, templateType] });
};
